import React from 'react';
import { PILL_BASE } from './Sheet';
import { safePad } from '../../../utils/safeArea';

const TAG_COLOR = { 'MATCHED ON MAP': '#22ECFB', CHECK: '#FF33C6', SUGGESTED: '#fff', 'FROM CHAT': 'rgba(255,255,255,.6)' };

/**
 * FILLED FROM {CHAT} (handoff §3): where each value on the Portal came from — field, value, the
 * quote, sender · time, and a CHECK tag on a guess. Read-only; Back goes to MAKE to change it.
 */
export default function SourcesSheet({ chatName, rows = [], onClose }) {
  return (
    <>
      <div aria-hidden data-testid="sources-backdrop" onPointerDown={onClose} style={{ position: 'absolute', inset: 0, zIndex: 9, background: 'rgba(0,0,0,.5)' }} />
      <div role="dialog" aria-modal="true" aria-label={`Filled from ${chatName}`} data-testid="sources-sheet" className="font-mono text-white" style={{ position: 'absolute', left: 0, right: 0, bottom: 0, zIndex: 10, background: '#000', borderRadius: '28px 28px 0 0', padding: safePad('20px 16px 18px'), display: 'flex', flexDirection: 'column', gap: 12, maxHeight: '70%', overflowY: 'auto', boxSizing: 'border-box', animation: 'prcSlideUp .44s cubic-bezier(.2,.7,.2,1) both' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.14em' }}>FILLED FROM {(chatName || 'THE CHAT').toUpperCase()}</span>
          <button type="button" onClick={onClose} style={{ ...PILL_BASE, background: 'none', color: '#fff', fontSize: 10, letterSpacing: '.12em', padding: '4px 0' }}>DONE</button>
        </div>
        <span style={{ fontFamily: 'Arial, sans-serif', fontSize: 12, lineHeight: 1.4, color: 'rgba(255,255,255,.6)' }}>Only you can see this. Go back a step to change any of it.</span>
        {rows.map((s) => (
          <div key={s.key} data-testid={`source-${s.key}`} style={{ display: 'flex', flexDirection: 'column', gap: 4, padding: '10px 12px', borderRadius: 14, background: 'rgba(255,255,255,.07)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
              <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.12em' }}>{s.field}</span>
              <span style={{ fontSize: 9, fontWeight: 700, letterSpacing: '.12em', color: TAG_COLOR[s.tag] || 'rgba(255,255,255,.6)' }}>{s.tag}</span>
            </div>
            <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.06em', color: 'rgba(255,255,255,.85)' }}>{s.value}</span>
            {s.quote && <span style={{ fontFamily: 'Arial, sans-serif', fontSize: 12, fontStyle: 'italic', color: 'rgba(255,255,255,.6)' }}>“{s.quote}”{s.src ? ` · ${s.src}` : ''}</span>}
          </div>
        ))}
      </div>
    </>
  );
}
